import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { addNativePushTapListener } from "./nativePush";
import { isNativeShell } from "./nativeShell";

export const DEFAULT_PUSH_TAP_PATH = "/triage";

/* Only same-app paths: "//host" and "scheme:" urls from a payload are ignored. */
export const pathFromPushUrl = (url: string | null): string => {
  if (url && url.startsWith("/") && !url.startsWith("//")) return url;
  return DEFAULT_PUSH_TAP_PATH;
};

export const useNativePushTap = (): void => {
  const history = useHistory();

  useEffect(() => {
    if (!isNativeShell()) return undefined;
    const remove = addNativePushTapListener({
      onTap: (url) => history.push(pathFromPushUrl(url)),
    });
    return (): void => {
      void remove.then((fn) => fn());
    };
  }, [history]);
};
